'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _PlanScorecardDefaultScorecard = require('./PlanScorecardDefaultScorecard.css');

var _PlanScorecardDefaultScorecard2 = _interopRequireDefault(_PlanScorecardDefaultScorecard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlanScorecardDefaultScorecard = (_dec = (0, _reactCssModules2.default)(_PlanScorecardDefaultScorecard2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PlanScorecardDefaultScorecard, _Component);

  function PlanScorecardDefaultScorecard(props) {
    (0, _classCallCheck3.default)(this, PlanScorecardDefaultScorecard);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PlanScorecardDefaultScorecard.__proto__ || (0, _getPrototypeOf2.default)(PlanScorecardDefaultScorecard)).call(this, props));

    _this.state = {
      currDefaultFund: props.fund,
      notPlan: props.notPlan || false
    };
    return _this;
  }

  (0, _createClass3.default)(PlanScorecardDefaultScorecard, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          currDefaultFund = _state.currDefaultFund,
          notPlan = _state.notPlan;

      if (!currDefaultFund) {
        this.context.router.push(_config2.default.routes.plans);
        return _react2.default.createElement(
          'div',
          { styleName: 'page' },
          _react2.default.createElement(_reactLoader2.default, {
            options: { scale: 0.70, top: '2.0rem' },
            loaded: false
          })
        );
      }

      //
      var fffIcon = require('../../../static/images/icons/fff-icon.svg');
      var ffbIcon = require('../../../static/images/icons/ffb-icon.svg');
      var ffiIcon = require('../../../static/images/icons/ffi-icon.svg');
      var dffIcon = require('../../../static/images/icons/dff-icon.svg');
      var gefIcon = require('../../../static/images/icons/gef-icon.svg');
      var gffIcon = require('../../../static/images/icons/gff-icon.svg');
      var pffIcon = require('../../../static/images/icons/pff-icon.svg');
      var wffIcon = require('../../../static/images/icons/wff-icon.svg');
      var tffIcon = require('../../../static/images/icons/tff-icon.svg');
      //

      var redOctagon = _react2.default.createElement(
        'div',
        { styleName: 'result-shape-txt-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'result-shape-wrap' },
          _react2.default.createElement('div', { title: 'Poor', styleName: 'red-octagon' })
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'result-val result-val-poor' },
          'Poor'
        )
      );
      var yellowSquare = _react2.default.createElement(
        'div',
        { styleName: 'result-shape-txt-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'result-shape-wrap' },
          _react2.default.createElement('div', { title: 'Fair', styleName: 'yellow-square' })
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'result-val result-val-fair' },
          'Fair'
        )
      );
      var greenCircle = _react2.default.createElement(
        'div',
        { styleName: 'result-shape-txt-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'result-shape-wrap' },
          _react2.default.createElement('div', { title: 'Good', styleName: 'green-circle' })
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'result-val result-val-good' },
          'Good'
        )
      );

      var shapeDecider = function shapeDecider(fund, grade_label) {
        var grade = fund[grade_label];
        if (grade >= 4) {
          return redOctagon;
        } else if (grade >= 2) {
          return yellowSquare;
        } else if (grade === 1) {
          return greenCircle;
        }
        return null;
      };
      //
      return _react2.default.createElement(
        'div',
        { styleName: 'snapshot-results' },
        _react2.default.createElement(
          _reactFlexboxGrid.Row,
          null,
          _react2.default.createElement(
            _reactFlexboxGrid.Col,
            { xs: 12, sm: 12, md: 6 },
            _react2.default.createElement(
              'div',
              { styleName: 'scorecard-shadow' },
              _react2.default.createElement(
                'h3',
                { styleName: 'th-e' },
                _react2.default.createElement(
                  'b',
                  null,
                  'Environment'
                ),
                ' ',
                _react2.default.createElement(_components.XsBr, null),
                'scorecard'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'result-card-wrap-row' },
                _react2.default.createElement(
                  _components.PlanScorecardResultModal,
                  { iyv: 'fff', fund: currDefaultFund, notPlan: notPlan },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'result-card-wrap' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'result-card' },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'result-lbl-icon-bbl' },
                        _react2.default.createElement('img', { styleName: 'result-lbl-icon', src: fffIcon, alt: 'Fossil fuels' })
                      ),
                      _react2.default.createElement(
                        'div',
                        { styleName: 'result-lbl' },
                        _react2.default.createElement(
                          'span',
                          { styleName: 'result-lbl-txt' },
                          'Fossil fuels'
                        )
                      ),
                      shapeDecider(currDefaultFund, 'grade_fossil')
                    )
                  )
                ),
                _react2.default.createElement(
                  _components.PlanScorecardResultModal,
                  { iyv: 'ffb', fund: currDefaultFund, notPlan: notPlan },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'result-card-wrap result-card-small' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'result-card' },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'result-lbl-icon-bbl' },
                        _react2.default.createElement('img', { styleName: 'result-lbl-icon', src: ffbIcon, alt: 'Fossil fuel finance' })
                      ),
                      _react2.default.createElement(
                        'div',
                        { styleName: 'result-lbl' },
                        _react2.default.createElement(
                          'span',
                          { styleName: 'result-lbl-txt' },
                          'Fossil fuel finance'
                        )
                      ),
                      shapeDecider(currDefaultFund, 'grade_fossil_bank')
                    )
                  )
                ),
                _react2.default.createElement(
                  _components.PlanScorecardResultModal,
                  { iyv: 'ffi', fund: currDefaultFund, notPlan: notPlan },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'result-card-wrap result-card-small' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'result-card' },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'result-lbl-icon-bbl' },
                        _react2.default.createElement('img', { styleName: 'result-lbl-icon', src: ffiIcon, alt: 'Fossil fuel insurance' })
                      ),
                      _react2.default.createElement(
                        'div',
                        { styleName: 'result-lbl' },
                        _react2.default.createElement(
                          'span',
                          { styleName: 'result-lbl-txt' },
                          'Fossil fuel insurance'
                        )
                      ),
                      shapeDecider(currDefaultFund, 'grade_fossil_insure')
                    )
                  )
                ),
                _react2.default.createElement(
                  _components.PlanScorecardResultModal,
                  { iyv: 'dff', fund: currDefaultFund, notPlan: notPlan },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'result-card-wrap' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'result-card' },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'result-lbl-icon-bbl' },
                        _react2.default.createElement('img', { styleName: 'result-lbl-icon', src: dffIcon, alt: 'Deforestation' })
                      ),
                      _react2.default.createElement(
                        'div',
                        { styleName: 'result-lbl' },
                        _react2.default.createElement(
                          'span',
                          { styleName: 'result-lbl-txt' },
                          'Deforestation'
                        )
                      ),
                      shapeDecider(currDefaultFund, 'grade_deforestation')
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'hidden-xs hidden-sm' },
              _react2.default.createElement(
                'div',
                { styleName: 'scorecard-methodology-link' },
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.routes.howitworks,
                    title: 'How it works',
                    transparentbutton: true
                  },
                  'Methodology',
                  _react2.default.createElement(_components.LinkIcon, null)
                )
              )
            )
          ),
          _react2.default.createElement(
            _reactFlexboxGrid.Col,
            { xs: 12, sm: 12, md: 6 },
            _react2.default.createElement(
              'div',
              { styleName: 'scorecard-shadow' },
              _react2.default.createElement(
                'h3',
                { styleName: 'th-s' },
                _react2.default.createElement(
                  'b',
                  null,
                  'Social'
                ),
                ' ',
                _react2.default.createElement(_components.XsBr, null),
                'scorecard'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'result-card-wrap-row' },
                _react2.default.createElement(
                  _components.PlanScorecardResultModal,
                  { iyv: 'gef', fund: currDefaultFund, notPlan: notPlan },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'result-card-wrap' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'result-card' },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'result-lbl-icon-bbl' },
                        _react2.default.createElement('img', { styleName: 'result-lbl-icon', src: gefIcon, alt: 'Gender equality' })
                      ),
                      _react2.default.createElement(
                        'div',
                        { styleName: 'result-lbl' },
                        _react2.default.createElement(
                          'span',
                          { styleName: 'result-lbl-txt' },
                          'Gender equality'
                        )
                      ),
                      shapeDecider(currDefaultFund, 'grade_gender_equality')
                    )
                  )
                ),
                _react2.default.createElement(
                  _components.PlanScorecardResultModal,
                  { iyv: 'gff', fund: currDefaultFund, notPlan: notPlan },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'result-card-wrap' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'result-card' },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'result-lbl-icon-bbl' },
                        _react2.default.createElement('img', { styleName: 'result-lbl-icon', src: gffIcon, alt: 'Civilian firearms' })
                      ),
                      _react2.default.createElement(
                        'div',
                        { styleName: 'result-lbl' },
                        _react2.default.createElement(
                          'span',
                          { styleName: 'result-lbl-txt' },
                          'Civilian firearms'
                        )
                      ),
                      shapeDecider(currDefaultFund, 'grade_guns')
                    )
                  )
                ),
                _react2.default.createElement(
                  _components.PlanScorecardResultModal,
                  { iyv: 'pff', fund: currDefaultFund, notPlan: notPlan },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'result-card-wrap' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'result-card' },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'result-lbl-icon-bbl' },
                        _react2.default.createElement('img', { styleName: 'result-lbl-icon', src: pffIcon, alt: 'Prison industrial complex' })
                      ),
                      _react2.default.createElement(
                        'div',
                        { styleName: 'result-lbl' },
                        _react2.default.createElement(
                          'span',
                          { styleName: 'result-lbl-txt' },
                          'Prison industrial complex'
                        )
                      ),
                      shapeDecider(currDefaultFund, 'grade_prison_industrial_complex')
                    )
                  )
                ),
                _react2.default.createElement(
                  _components.PlanScorecardResultModal,
                  { iyv: 'wff', fund: currDefaultFund, notPlan: notPlan },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'result-card-wrap' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'result-card' },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'result-lbl-icon-bbl' },
                        _react2.default.createElement('img', { styleName: 'result-lbl-icon', src: wffIcon, alt: 'Military weapons' })
                      ),
                      _react2.default.createElement(
                        'div',
                        { styleName: 'result-lbl' },
                        _react2.default.createElement(
                          'span',
                          { styleName: 'result-lbl-txt' },
                          'Military weapons'
                        )
                      ),
                      shapeDecider(currDefaultFund, 'grade_military')
                    )
                  )
                ),
                _react2.default.createElement(
                  _components.PlanScorecardResultModal,
                  { iyv: 'tff', fund: currDefaultFund, notPlan: notPlan },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'result-card-wrap' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'result-card' },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'result-lbl-icon-bbl' },
                        _react2.default.createElement('img', { styleName: 'result-lbl-icon', src: tffIcon, alt: 'Tobacco' })
                      ),
                      _react2.default.createElement(
                        'div',
                        { styleName: 'result-lbl' },
                        _react2.default.createElement(
                          'span',
                          { styleName: 'result-lbl-txt' },
                          'Tobacco'
                        )
                      ),
                      shapeDecider(currDefaultFund, 'grade_tobacco')
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'hidden-md hidden-lg' },
          _react2.default.createElement(
            'div',
            { styleName: 'scorecard-methodology-link' },
            _react2.default.createElement(
              _components.Link,
              {
                to: _config2.default.routes.howitworks,
                title: 'How it works',
                transparentbutton: true
              },
              'Methodology',
              _react2.default.createElement(_components.LinkIcon, null)
            )
          )
        )
      );
    }
  }]);
  return PlanScorecardDefaultScorecard;
}(_react.Component), _class2.contextTypes = {
  router: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = PlanScorecardDefaultScorecard;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PlanScorecardDefaultScorecard/PlanScorecardDefaultScorecard.js
// module id = 1414
// module chunks = 0